import React, {Component} from 'react';
import Breadcrumb from "../common/breadcrumb";

class PrivacyPolicy extends Component {

    constructor (props) {
        super (props)
    }

    render (){

        return (
            <div>
                <Breadcrumb title={'Política de Privacidad'}/>

                <section className="about-page section-b-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <p><em>Última actualización: 16 de julio de 2026</em></p>

                                <p>Esta Política de Privacidad describe cómo <strong>Wewith</strong> ("nosotros")
                                    recopila, usa y protege la información de las personas que utilizan nuestra
                                    aplicación y servicios ("la App").</p>

                                <h4>1. Información que recopilamos</h4>
                                <p>Podemos recopilar datos como nombre, número de teléfono, dirección de entrega,
                                    correo electrónico e historial de pedidos, ya sea porque el usuario los
                                    proporciona directamente o a través de la interacción con nuestros canales,
                                    incluyendo WhatsApp.</p>

                                <h4>2. Uso de la información</h4>
                                <p>Utilizamos esta información para procesar pedidos, coordinar entregas, brindar
                                    soporte al cliente y comunicarnos con el usuario a través de WhatsApp u otros
                                    canales que el usuario haya autorizado.</p>

                                <h4>3. Compartir información</h4>
                                <p>No vendemos ni compartimos la información personal de nuestros usuarios con
                                    terceros con fines comerciales. Solo compartimos información con proveedores
                                    necesarios para operar el servicio (por ejemplo, plataformas de mensajería como
                                    WhatsApp Business/Meta), bajo los estándares de confidencialidad
                                    correspondientes.</p>

                                <h4>4. Conservación de datos</h4>
                                <p>Conservamos la información mientras sea necesaria para prestar el servicio o
                                    cumplir con obligaciones legales.</p>

                                <h4>5. Eliminación de datos</h4>
                                <p>El usuario puede solicitar la eliminación de sus datos personales en cualquier
                                    momento. Consulta nuestras <a href={`${process.env.PUBLIC_URL}/data-deletion`}>Instrucciones
                                        de Eliminación de Datos</a> para más información.</p>

                                <h4>6. Seguridad</h4>
                                <p>Implementamos medidas razonables para proteger la información contra accesos no
                                    autorizados, pérdida o mal uso.</p>

                                <h4>7. Contacto</h4>
                                <p>Para consultas sobre esta Política de Privacidad, puedes escribirnos por WhatsApp
                                    al <a href="https://wa.me/51944847482" target="_blank" rel="noopener noreferrer">+51
                                        944 847 482</a>.</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default PrivacyPolicy
